/**
 * Honorarios usados recientemente, por organización.
 *
 * Vive en `localStorage` a propósito: es una comodidad del dispositivo, no un
 * dato del negocio. No se sincroniza, no se audita y perderlo no cuesta nada.
 * Va en su propio módulo para que `ServicePicker` exporte sólo el componente.
 */
const CLAVE = 'gv.honorarios-recientes';
const MAXIMO = 5;

const claveDe = (organizationId: string) => `${CLAVE}.${organizationId}`;

export function leerRecientes(organizationId: string): string[] {
  try {
    const raw = localStorage.getItem(claveDe(organizationId));
    const arr: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    // Un almacenamiento no disponible o corrupto no puede romper el formulario.
    return [];
  }
}

export function registrarReciente(organizationId: string, serviceId: string) {
  try {
    const previos = leerRecientes(organizationId).filter((id) => id !== serviceId);
    localStorage.setItem(
      claveDe(organizationId),
      JSON.stringify([serviceId, ...previos].slice(0, MAXIMO)),
    );
  } catch {
    // Sin almacenamiento el formulario funciona igual, sólo sin "recientes".
  }
}
